module.exports = __webpack_public_path__ + "static/img/fz_lhb_ys.78e8723.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_lhb_ys.png
// module id = IU00
// module chunks = 0